import { useAuth } from "../App";

/**
 * Convenience hook for subscription/billing state.
 * Reads from the subscription object in AuthContext.
 */
export function useSubscription() {
  const { subscription, fetchSubscription } = useAuth();

  const isUltra =
    subscription?.plan_type === "ultra" &&
    subscription?.subscription_status === "active";

  // isPro is true for both Pro and Ultra subscribers (Ultra includes all Pro features)
  const isPro =
    ["pro", "ultra"].includes(subscription?.plan_type) &&
    subscription?.subscription_status === "active";

  const isTrialActive = subscription?.trial_active ?? false;
  const trialDaysRemaining = subscription?.trial_days_remaining ?? 0;
  const isTrialExpired = !isTrialActive && !isPro;
  const postsUsedToday = subscription?.posts_used_today ?? 0;
  const postsRemainingToday = subscription?.posts_remaining_today ?? null; // null = unlimited

  return {
    subscription,
    isPro,
    isUltra,
    isTrialActive,
    trialDaysRemaining,
    isTrialExpired,
    postsUsedToday,
    postsRemainingToday,
    refetch: fetchSubscription,
  };
}
